export default __webpack_public_path__ + "static/media/Educational.bd3fbc15.svg";